import { z } from 'zod';

export const getIsMemberZodSchema = z
  .object({
    member: z.boolean(),
  })
  .transform((v): { isMember: boolean } => {
    return { isMember: v.member };
  });
